/* eslint-disable no-console */
Vue.config.devtools = process.env.NODE_ENV === 'development';

import 'es6-promise/auto' // Promise polyfill

import Vue from 'vue'
import { store } from './store'
import Element from 'element-ui'
import App from './App.vue'
import locale from 'element-ui/lib/locale/lang/en'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/sass/style.scss'

import './filters';

import { BridgeAPI } from  './bridge';

BridgeAPI.sendIdentify();

Vue.use(Element, { locale })

Vue.config.productionTip = false

new Vue({
  store,
  render: h => h(App),
}).$mount('#app')
